<template>
  <div class="container register">
    <v-card max-width="70%" class="logincard mx-auto">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-size:30px; font-family: 'Nunito', sans-serif;"
>
        <v-img class="imagelogin" max-width="20%" src="img/d1.png" style="opacity: 0.9 "/>
      </v-card-title>
      <div class="ml-5 mr-5 mt-8">
        <v-card-text>
          <v-text-field
            type="number"
            required
            min="1.0"
            max="0"
            prepend-icon="mdi-phone"
            label="Enter your Registered Mobile Number"
            v-model="form.mobile"
            placeholder="eg : 9999999999"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength = "10"
          />
          <v-text-field
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            @click:append="show = !show"
            required
            prepend-icon="mdi-lock"
            label="Enter password"
            v-model="form.password"
            @keyup.enter="login"
            placeholder="Should Be Upto 8 characters"
          />
        </v-card-text>
      </div>
      <v-card-actions>
        <v-row justify="center" v-if="!loading">
          <Button
            cssClass="mb-1 mr-2 ml-2 login"
            @click="login"
            rounded
            label="Login"
            color="primary"
          />
          <Button
            @click="goTo('/register')"
            cssClass="mb-1 mr-2 ml-2 login"
            rounded
            label="Register"
            color="primary"
          />
        </v-row>
        <div style="margin: auto" v-else>
          <v-progress-circular indeterminate />
        </div>
      </v-card-actions>
      <v-card-actions>
        <v-row justify="center">
          <Button
            @click="goTo('/forgot-password')"
            cssClass="forgotpw"
            text
            label="Forgot password"
            color="primary"
          />
        </v-row>
      </v-card-actions>
      <b-link href="https://play.google.com/store/apps/details" target="_blank">
        <v-img
          class="mx-auto"
          style="width:120px; cursor: pointer;"
          src="/img/google-play-badge.png"
        />
      </b-link>
    </v-card>
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
import { login as loginService } from "../../services/register";
import { mapActions } from "vuex";
import { extractError } from "../../utils/error";
import { resentOTP as resendOTPService } from "../../services/register";
export default {
  data() {
    return {
      show: false,
      loading: false,
      form: {
        password: "",
        mobile: ""
      }
    };
  },
  components: {
    Button
  },
  computed: {
    number() {
      return this.$route.params.number;
    }
  },
  methods: {
    async login() {
      try {
        this.loading = true;
        console.log({ loginform: this.form });
        const result = await loginService(this.form);
        console.log("login response : ", result);
        this.loading = false;
        const {
          response: { user }
        } = result;
        this.setUser(user);
        localStorage.setItem("in:user", JSON.stringify(user));
        this.$router.push({
          name: "Dashboard"
        });
      } catch (err) {
        this.loading = false;
        if (err.message.error === "yet otp not verified") {
          alert("Otp Not Verified Click Ok to Continue Verification");
          //if condition of otp not verified
          const userId = err.message.info;
          try {
            this.resending = true;
            await resendOTPService(this.form.mobile);
            this.$toasted.success(
              "Enter Otp Sent to your Registered Mobile number",
              {
                duration: 4000
              }
            );
            this.resending = false;
          } catch (err) {
            this.resending = false;
            console.log(err);
            this.$showError("Could not resend OTP");
          }
          console.log({ moblie: this.form.mobile });
          this.$router.push({
            name: "Otp",
            params: {
              userId,
              number: this.form.mobile,
              forwardedfrom: "login"
            }
          });
        }
        const message = extractError(err);
        if (err.message.error === "yet otp not verified") {
          //not empty

        } else {
          this.$showError(message);
        }
      }
    },
    ...mapActions("auth", ["setUser"]),

    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    }
  }
};
</script>
<style scoped>
.register {
  background-image: url("/img/authentication.jpg");
  background-size: cover;
  background-position: center;
  max-width: 100%;
  height: 100% !important;
}
.logincard {
  margin-top: 4rem !important;
}
.imagelogin {
  margin-top: -20px !important;

  margin-bottom: -20px !important;
}
</style>
<style>
.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  font-size: 14px !important;
}

.v-btn:focus {
  outline: none !important;
}

.login {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.loginmain {background: rgb(104,134,158);
background: linear-gradient(90deg, rgb(121, 153, 179) 0%, rgb(183, 206, 226) 48%, rgb(121, 153, 179) 100%);
  padding: 30px 10px !important;
}
</style>
